// extracted by mini-css-extract-plugin
export default {"centered":"_1G34u","unsubscribe-width":"_1JEUb","unsubscribeWidth":"_1JEUb"};